(() => {
  class ApexReviews extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      if (!this.cards.length) return;
      this.visible = 5;
      this.filter = this.querySelector('[data-review-filter]');
      this.sort = this.querySelector('[data-review-sort]');
      this.more = this.querySelector('[data-review-more]');
      this.filter?.addEventListener('change', () => { this.visible = 5; this.update(); });
      this.sort?.addEventListener('change', () => { this.visible = 5; this.update(); });
      this.more?.addEventListener('click', () => { this.visible += 5; this.update(); });
      this.querySelector('[data-review-controls]').hidden = false;
      this.dialog = this.querySelector('[data-review-lightbox]');
      if (this.dialog && typeof this.dialog.showModal === 'function') {
        this.querySelectorAll('[data-review-photo]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.photoOpener = link;
          this.photoLinks = [...link.closest('[data-review-card]').querySelectorAll('[data-review-photo]')];
          this.photoIndex = this.photoLinks.indexOf(link);
          this.showPhoto();
          this.dialog.showModal();
        }));
        this.querySelector('[data-review-photo-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => { this.photoOpener?.focus(); this.querySelector('[data-review-photo-full]').removeAttribute('src'); });
        this.querySelector('[data-review-photo-prev]').addEventListener('click', () => this.showPhoto(-1));
        this.querySelector('[data-review-photo-next]').addEventListener('click', () => this.showPhoto(1));
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.showPhoto(event.key === 'ArrowRight' ? 1 : -1); }
        });
      }
      this.update();
    }
    showPhoto(direction = 0) {
      this.photoIndex = (this.photoIndex + direction + this.photoLinks.length) % this.photoLinks.length;
      const link = this.photoLinks[this.photoIndex];
      const image = this.querySelector('[data-review-photo-full]');
      image.src = link.href;
      image.alt = link.getAttribute('aria-label') || '';
      this.querySelector('[data-review-photo-count]').textContent = `${this.photoIndex + 1} / ${this.photoLinks.length}`;
      this.querySelector('[data-review-photo-prev]').hidden = this.photoLinks.length < 2;
      this.querySelector('[data-review-photo-next]').hidden = this.photoLinks.length < 2;
    }
    update() {
      const filter = this.filter?.value || 'all';
      const sort = this.sort?.value || 'newest';
      const cards = this.cards.filter(card => filter === 'all' || card.dataset.rating === filter).sort((a, b) => {
        if (sort === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || Number(b.dataset.date) - Number(a.dataset.date);
        if (sort === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || Number(b.dataset.date) - Number(a.dataset.date);
        return Number(b.dataset.date) - Number(a.dataset.date);
      });
      const list = this.querySelector('[data-review-list]');
      this.cards.forEach(card => { card.hidden = true; });
      cards.forEach((card, index) => { card.hidden = index >= this.visible; list.append(card); });
      this.more.hidden = cards.length <= this.visible;
      this.querySelector('[data-review-no-results]').hidden = cards.length > 0;
    }
  }
  if (!customElements.get('apex-reviews')) customElements.define('apex-reviews', ApexReviews);
})();
